// START IMPORTS
// Theme and UI imports
import { Box, Stack, styled } from '@ltvco/refresh-lib/theme';
// Core lib v2 imports
import {
  QueryParams,
  FilterTypeOption,
  ReportFilter,
  SortBy,
  SortDirection,
  SearchComponent,
  FiltersComponent,
  SortComponent,
} from '@ltvco/refresh-lib/v2';
// END IMPORTS

// START STYLED_COMPONENTS
const SearchParentContainer = styled(Box)(() => ({
  '& .MuiSvgIcon-root': {
    color: 'white',
  },
}));
// END STYLED_COMPONENTS

// START INTERFACES_AND_TYPES
type SearchAndFilterControlsProps = {
  queryParams: QueryParams;
  setQueryParams: any;
  reportTypeFilterOptions: { [key: string]: FilterTypeOption };
  filterTypes: ReportFilter[];
  setFilterTypes: (reportTypes: ReportFilter[]) => void;
  sort_by: SortBy;
  sort_direction: SortDirection;
};
// END INTERFACES_AND_TYPES

export function SearchAndFilterControls({
  queryParams,
  setQueryParams,
  reportTypeFilterOptions,
  filterTypes,
  setFilterTypes,
  sort_by,
  sort_direction,
}: SearchAndFilterControlsProps) {
  // START RENDER
  return (
    <Stack direction={{ xl: 'row', xs: 'column' }} spacing={1.5}>
      <SearchParentContainer>
        <SearchComponent
          queryParams={queryParams}
          setQueryParams={setQueryParams}
        />
      </SearchParentContainer>
      <Stack direction="row" spacing={1.5}>
        <FiltersComponent
          reportTypeOptions={reportTypeFilterOptions}
          reportTypes={filterTypes}
          setReportTypes={setFilterTypes}
        />
        <SortComponent
          currentSort={{ sort_by, sort_direction }}
          setQueryParams={setQueryParams}
        />
      </Stack>
    </Stack>
  );
  // END RENDER
}
